import AlbumOutlinedIcon from "@mui/icons-material/AlbumOutlined";
import CallSplitIcon from "@mui/icons-material/CallSplit";
import ContactPhoneOutlinedIcon from "@mui/icons-material/ContactPhoneOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import Diversity2Icon from "@mui/icons-material/Diversity2";
import DonutSmallOutlinedIcon from "@mui/icons-material/DonutSmallOutlined";
import LibraryMusicIcon from "@mui/icons-material/LibraryMusic";
import LyricsIcon from "@mui/icons-material/Lyrics";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import SmartDisplayOutlinedIcon from "@mui/icons-material/SmartDisplayOutlined";
import SpatialAudioOffIcon from "@mui/icons-material/SpatialAudioOff";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";

import constantsData from "@/data/constants";
import permissionsData from "@/data/permissions";
import urlsData from "@/data/urls";

const {
    artists: { url: artistsRouteUrl },
    clients: { url: clientsRouteUrl },
    // eslint-disable-next-line destructuring-newline/object-property-newline
    contributors: { roleMapping: contributorRoleMappingRouteUrl, url: contributorsRouteUrl },
    distributions: distributionsRouteUrl,
    home: homeRouteUrl,
    permissions: permissionsRouteUrl,
    releases: { url: releasesRouteUrl },
    revenueReports: { url: revenueReportsRouteUrl },
    territories: { url: territoriesRouteUrl },
    tracks: {
        formats: { url: tracksFormatsRouteUrl },
        url: tracksRouteUrl,
    },
    users: { url: usersRouteUrl },
    videos: videosRouteUrl,
} = urlsData.routes;

const {
    accountRead: accountReadPermission,
    mediaRead: mediaReadPermission,
    reportRead: reportReadPermission,
} = permissionsData.permissions.keys;

// A tab may carry a `children` array of nested tabs, which the sidebar renders as a collapsible group.
const tabs = [
    {
        Icon: DashboardOutlinedIcon,
        id: 1,
        key: "home",
        permissions: [mediaReadPermission],
        routeUrl: homeRouteUrl,
    },
    {
        Icon: SpatialAudioOffIcon,
        id: 2,
        key: "artists",
        permissions: [mediaReadPermission],
        routeUrl: artistsRouteUrl,
    },
    {
        children: [
            {
                id: 14,
                key: "roleMapping",
                permissions: [mediaReadPermission],
                routeUrl: contributorRoleMappingRouteUrl,
            },
        ],
        Icon: Diversity2Icon,
        id: 3,
        key: "contributors",
        permissions: [mediaReadPermission],
        routeUrl: contributorsRouteUrl,
    },
    {
        Icon: LibraryMusicIcon,
        id: 4,
        key: "releases",
        permissions: [mediaReadPermission],
        routeUrl: releasesRouteUrl,
    },
    {
        Icon: CallSplitIcon,
        id: 5,
        key: "distributions",
        permissions: [mediaReadPermission],
        routeUrl: distributionsRouteUrl,
    },
    {
        Icon: AlbumOutlinedIcon,
        id: 6,
        key: "tracks",
        permissions: [mediaReadPermission],
        routeUrl: tracksRouteUrl,
    },
    {
        Icon: LyricsIcon,
        id: 7,
        key: "tracksFormats",
        permissions: [mediaReadPermission],
        routeUrl: tracksFormatsRouteUrl,
    },
    {
        Icon: SmartDisplayOutlinedIcon,
        id: 8,
        key: "videos",
        permissions: [mediaReadPermission],
        routeUrl: videosRouteUrl,
    },
    {
        Icon: PeopleAltOutlinedIcon,
        id: 9,
        key: "users",
        permissions: [accountReadPermission],
        routeUrl: usersRouteUrl,
    },
    {
        Icon: ContactPhoneOutlinedIcon,
        id: 10,
        key: "clients",
        oneOfPermissions: true,
        permissions: [mediaReadPermission, reportReadPermission],
        routeUrl: clientsRouteUrl,
    },
    {
        ...(import.meta.env.VITE_ENABLE_REVENUE_REPORTS === "true" && {
            Icon: RequestQuoteOutlinedIcon,
            id: 11,
            key: "revenueReports",
            permissions: [reportReadPermission],
            routeUrl: revenueReportsRouteUrl,
        }),
    },
    {
        Icon: DonutSmallOutlinedIcon,
        id: 12,
        key: "territories",
        permissions: [mediaReadPermission],
        routeUrl: territoriesRouteUrl,
    },
    {
        Icon: VerifiedUserOutlinedIcon,
        hasRoles: true,
        id: 13,
        key: "permissions",
        roles: [constantsData.superAdmins],
        routeUrl: permissionsRouteUrl,
    },
];

// Every routable tab and nested child, keyed by url, so `App` can resolve the active tab (and its parent) from the
// current location without the two lists ever drifting apart.
const routes = tabs.reduce((accumulator, { children, id, routeUrl }) => {
    if (routeUrl) accumulator[routeUrl] = { id, parentId: null };

    children?.forEach(({ id: childId, routeUrl: childRouteUrl }) => {
        if (childRouteUrl) accumulator[childRouteUrl] = { id: childId, parentId: id };
    });

    return accumulator;
}, {});

const sidebarData = {
    routes,
    tabs,
};

export default sidebarData;
